import { render, staticRenderFns } from "./pwa_splash.vue?vue&type=template&id=13952eb7&scoped=true&"
import script from "./pwa_splash.vue?vue&type=script&lang=js&"
export * from "./pwa_splash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13952eb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13952eb7')) {
      api.createRecord('13952eb7', component.options)
    } else {
      api.reload('13952eb7', component.options)
    }
    module.hot.accept("./pwa_splash.vue?vue&type=template&id=13952eb7&scoped=true&", function () {
      api.rerender('13952eb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/images/pwa_splash.vue"
export default component.exports